import React from 'react';
import OpinionDetailView from '../components/OpinionDetailView';
import { Helmet } from 'react-helmet-async';

const OpinionDetail = () => {
  return (
    <div className="w-full mobile-content-container" style={{width: '100%', maxWidth: '100%'}}>
      <Helmet>
        <title>Opinion | Cult of the Red Hat</title>
        {/* The specific meta tags are set in OpinionDetailView based on the loaded opinion */}
      </Helmet>
      
      <OpinionDetailView />
    </div>
  );
};

export default OpinionDetail;